import React from 'react'
import { Pagination } from '@mui/material'
import { styled } from '@mui/material/styles'

interface PaginationPropsType {
  currentPage: number
  totalItemCount: number
  limitPerPage: number
  setCurrentPage: (page: number) => void
}

const CustomPagination = styled(Pagination)(() => ({
  '& .MuiPaginationItem-root': {
    border: 'none',
    borderRadius: '0',
    padding: '4px 8px',
    color: '#FFFFFF66',
    backgroundColor: 'transparent',
    transition: 'background-color 0.3s ease-in-out',
  },
  '& .Mui-selected': {
    backgroundColor: 'transparent !important',
    color: 'white',
    borderTop: '2px solid #FB5012',
    borderRadius: '0',
  },
  '& .MuiPaginationItem-previousNext': {
    display: 'none',
  },
}))

const CustomPageNavigator: React.FC<PaginationPropsType> = ({
  currentPage,
  totalItemCount,
  limitPerPage,
  setCurrentPage,
}) => {
  const totalPages = Math.ceil(totalItemCount / limitPerPage)

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1
      setCurrentPage(newPage)
    }
  }

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1
      setCurrentPage(newPage)
    }
  }

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setCurrentPage(value)
  }

  return (
    <div className="table-pagination-container pb-2">
      <div
        className={`pagination-btn-wrapper ${
          currentPage === 1 ? 'opacity-[0.3]' : ''
        }`}
        onClick={handlePreviousPage}
      >
        <img src="/icon/Arrow left.svg" alt="Previous" /> Previous
      </div>
      <div>
        <CustomPagination
          count={totalPages}
          page={currentPage}
          color="primary"
          onChange={handlePageChange}
        />
      </div>
      <div
        className={`pagination-btn-wrapper ${
          currentPage === totalPages ? 'opacity-[0.3]' : ''
        }`}
        onClick={handleNextPage}
      >
        Next <img src="/icon/Arrow right.svg" alt="Next" />
      </div>
    </div>
  )
}

export default CustomPageNavigator
